/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrimaryIndustry
 */
export interface PrimaryIndustry {
}

/**
 * Check if a given object implements the PrimaryIndustry interface.
 */
export function instanceOfPrimaryIndustry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrimaryIndustryFromJSON(json: any): PrimaryIndustry {
    return PrimaryIndustryFromJSONTyped(json, false);
}

export function PrimaryIndustryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryIndustry {
    return json;
}

export function PrimaryIndustryToJSON(value?: PrimaryIndustry | null): any {
    return value;
}

